import React from 'react';
import { motion } from 'framer-motion';
import { Settings, TrendingUp, ShieldCheck } from 'lucide-react';
const steps = [{
  icon: Settings,
  title: 'Week 1: Setup',
  description: 'We build your complete system',
  delay: 0
}, {
  icon: TrendingUp,
  title: 'Week 2-4: Optimize',
  description: 'Fine-tune based on your business',
  delay: 0.2
}, {
  icon: ShieldCheck,
  title: 'Ongoing: Manage',
  description: 'Monthly maintenance and improvements',
  delay: 0.4
}];
export function ProcessSection() {
  return <section className="py-24 bg-slate-50" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-168">
            The Process
          </h2>
          <p className="text-xl text-slate-600" data-id="element-169">
            Simple, transparent, and effective
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-170">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-200 -translate-y-1/2 z-0" data-id="element-171" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-172">
            {steps.map((step, index) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: step.delay,
            duration: 0.5
          }} className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 flex flex-col items-center text-center" data-id="element-173">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 mb-6" data-id="element-174">
                  <step.icon className="w-8 h-8" data-id="element-175" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-176">
                  {step.title}
                </h3>
                <p className="text-slate-600" data-id="element-177">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}